const carView = {
  bindings: {
    train: '<',
    carNumber: '<',
  },
  templateUrl: '/modules/configurationManagement/car-view/car-view.html',
  controller: 'CarViewController',
};

angular
  .module('configuration-management.module')
  .component('carView', carView)
  .config(function($stateProvider) {
    $stateProvider.state('car.details', {
      url: '/details',
      views: {
        'cartab@carNumber': 'carView',
      },
    });
  });
